import React, { useState, useEffect } from 'react';
import { getEdnaAccessList } from '../../../functions/Api';
import EnhancedTable from './EnhancedTable';
// import ActionButtons from './ActionButtons';
import Spinner from '../../Spinner';
import { Button } from '@asu/unity-react-core';
import { useLocation, useNavigate } from 'react-router-dom';

function Users() {
  const location = useLocation();
  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [loaded, setLoaded] = useState(false);
  const [loading, setLoading] = useState(false);
  const [viewAs, setViewAs] = useState('');
  // const [newUser, setNewUser] = useState({
  //   user_id: '',
  //   role: 'ROLE_SYLLABUS_ADMIN',
  // });

  useEffect(() => {
    if (!loaded) {
      loadUsers();
      setLoaded(true);
    }
  }, [users]);

  const handleViewAs = () => {
    window.open(`/?viewAs=${encodeURIComponent(viewAs)}`, '_blank');
  };

  const loadUsers = async () => {
    setLoading(true);
    try {
      let access = await getEdnaAccessList();

      access = access.map((user) => ({
        user_id: user.asuriteid,
        name: user.name,
      }));

      setUsers(access);
    } catch (error) {
      console.log(error);
    }
    setLoading(false);
  };

  return (
    <>
      <div className="users">
        <div className="d-flex justify-content-between align-items-center">
          <h2>View Users</h2>
          <div className="d-flex gap-1 align-items-center">
            <span className="fw-bold">View as</span>
            <input
              type="text"
              placeholder="ASURITE"
              value={viewAs}
              onChange={(e) => setViewAs(e.target.value)}
            />
            <Button label="View" size="small" onClick={handleViewAs} />
          </div>
        </div>
        {/* <ActionButtons
          selectedUsers={selectedUsers}
          setSelectedUsers={setSelectedUsers}
          newUser={newUser}
          setNewUser={setNewUser}
          users={users}
          setUsers={setUsers}
        /> */}

        {loading && <Spinner />}
        {!loading && users && users.length && (
          <EnhancedTable
            rows={users}
            selected={selectedUsers}
            setSelected={setSelectedUsers}
          />
        )}
      </div>
    </>
  );
}

export default Users;
